export default {
  name: 'marking--reportDropoutType',
};